<div class="page-container container">
  <app-utility-toolbar />
  <h1 class="header col-12">Upload File</h1>
  <div>
    <form [formGroup]="myForm">
      <div class="row">
        <div class="col-6">
          <mat-form-field class="col-6 ps-0">
            <mat-label>Upload Type</mat-label>
            <mat-select
              [formControlName]="'type'"
              (selectionChange)="updateForm()"
            >
              @for (uploadType of uploadTypes; track uploadType.value) {
                <mat-option [value]="uploadType.value">
                  {{ uploadType.name }}
                </mat-option>
              }
            </mat-select>
            <mat-error>This field is required</mat-error>
          </mat-form-field>

          @if (myForm.value.type !== 'user') {
            <mat-form-field class="col-6 p-0">
              <mat-label>Solution</mat-label>
              <mat-select [formControlName]="'solution'">
                @for (solution of solutions; track solution.value) {
                  <mat-option [value]="solution.value">
                    {{ solution.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
          }

          <div class="mb-3">
            @if (myForm.value.type === 'unitProfileXml') {
              <mat-form-field class="col-6 ps-0">
                <mat-label>Mass Upload</mat-label>
                <mat-select
                  [formControlName]="'massUpload'"
                  (selectionChange)="updateForm()"
                >
                  <mat-option [value]="false"> No </mat-option>
                  <mat-option [value]="true"> Yes </mat-option>
                </mat-select>
                <mat-error>This field is required</mat-error>
              </mat-form-field>
            }

            @if (
              myForm.value.type === 'unitProfileXml' &&
              myForm.value.massUpload === false
            ) {
              <mat-form-field class="col-6 p-0">
                <input
                  type="text"
                  placeholder="Search For a Unit"
                  matInput
                  name="unit"
                  [formControl]="myForm.get('unit')"
                  [matAutocomplete]="auto"
                />
                <mat-label>Unit</mat-label>
                <mat-autocomplete #auto="matAutocomplete">
                  @for (unit of filteredUnits | async; track unit.id) {
                    <mat-option [value]="unit.id">
                      {{ unit.name }}
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error>This field is required</mat-error>
              </mat-form-field>
            }

            <span class="col-12 p-0">
              <input
                #fileUpload
                type="file"
                class="file-input"
                (change)="onFileSelected($event)"
              />

              <span class="file-upload">
                {{ fileName || 'No file selected yet' }}

                <button
                  type="button"
                  mat-mini-fab
                  color="primary"
                  class="upload-btn"
                  (click)="fileUpload.click()"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>
              </span>
            </span>
          </div>

          @if (myForm.value.type === 'unitProfileXml') {
            <mat-form-field class="col-6 p-0">
              <mat-label>Bug Tracker ID</mat-label>
              <input
                type="text"
                placeholder="Bug Tracker ID"
                matInput
                name="bugTrackerId"
                formControlName="bugTrackerId"
              />
            </mat-form-field>

            <div class="failure">
              <strong>
                IMPORTANT:<br />
                <ol>
                  <li
                    >Notes for Unit Profiles will be seen by Home Office Users
                    in the Unit History Report.</li
                  >
                  <li
                    >Unit Profile notes should be a high level description. All
                    details are logged in bug tracker (documents, pictures).</li
                  >
                  <li
                    >Include the bug tracker id, or create one if it does not
                    exist, for all Unit Profiles.</li
                  >
                </ol>
              </strong>
            </div>
          }

          @if (myForm.value.type !== 'user') {
            <mat-form-field class="col-12 p-0">
              <textarea
                rows="7"
                matInput
                [formControlName]="'note'"
                [placeholder]="notePlaceholder"
              ></textarea>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
          }

          <div>
            <button
              type="button"
              class="ms-auto"
              mat-raised-button
              color="accent"
              (click)="onFileSubmit()"
            >
              <mat-icon>file_upload</mat-icon>Upload
            </button>
          </div>

          <h4 class="pt-5 ps-3 {{ statusClass }}">
            {{ status }}
            @if (
              statusClass === 'success' &&
              myForm.value.type === 'unitProfileXml'
            ) {
              to {{ unitSuccess }}
            }
          </h4>
        </div>

        <div class="col-6">
          <app-build-information />
        </div>
      </div>
    </form>
  </div>
</div>
